__turbopack_context__.v({
  "button": "content404-module-scss-module__Pj4m_q__button",
  "container": "content404-module-scss-module__Pj4m_q__container",
  "details": "content404-module-scss-module__Pj4m_q__details",
  "title": "content404-module-scss-module__Pj4m_q__title",
  "titleContainer": "content404-module-scss-module__Pj4m_q__titleContainer",
});
